"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_router_dom_1 = require("react-router-dom");

var AdvancedPage_1 = __importDefault(require("./AdvancedPage"));

var ConfirmPage_1 = __importDefault(require("./ConfirmPage"));

var HomePage_1 = __importDefault(require("./HomePage"));

var ReceiptPage_1 = __importDefault(require("./ReceiptPage"));

var ReceivePage_1 = __importDefault(require("./ReceivePage"));

var SendPage_1 = __importDefault(require("./SendPage"));

var Pages = function Pages(_a) {
  var pluginData = _a.pluginData;
  return react_1.default.createElement(react_router_dom_1.Switch, null, react_1.default.createElement(react_router_dom_1.Route, {
    path: "/",
    exact: true,
    component: HomePage_1.default
  }), react_1.default.createElement(react_router_dom_1.Route, {
    path: "/receive",
    component: ReceivePage_1.default
  }), react_1.default.createElement(react_router_dom_1.Route, {
    path: "/send",
    component: SendPage_1.default
  }), react_1.default.createElement(react_router_dom_1.Route, {
    path: "/confirm",
    component: ConfirmPage_1.default
  }), react_1.default.createElement(react_router_dom_1.Route, {
    path: "/receipt/:asset/:txHash",
    component: ReceiptPage_1.default
  }), react_1.default.createElement(react_router_dom_1.Route, {
    path: "/advanced",
    component: AdvancedPage_1.default
  }), pluginData.pages.map(function (_a) {
    var path = _a.path,
        Component = _a.Component,
        plugin = _a.plugin;
    return react_1.default.createElement(react_router_dom_1.Route, {
      path: path,
      key: path,
      render: function render(props) {
        return react_1.default.createElement(Component, __assign({
          plugin: plugin
        }, props));
      }
    });
  }), react_1.default.createElement(react_router_dom_1.Redirect, {
    to: "/"
  }));
};

exports.default = Pages;